import { createContext, useContext, useEffect, useId } from 'react';

export interface ScienceTutorContext {
  subjectKey: 'chemistry' | 'physics';
  toolId: string;
  state: Record<string, unknown>;
}
export interface Section { name: string; inputs: Record<string, unknown> }
interface SnapshotRegistry {
  update: (id: string, section: Section | null) => void;
}
export const Registry = createContext<SnapshotRegistry | null>(null);

/** Share learner inputs only. Reviewed case objects contain hidden answer keys. */
export function tutorSelection(value: unknown): unknown {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  const data = value as Record<string, unknown>;
  return Object.fromEntries(['id', 'name', 'title', 'label', 'symbol'].filter((key) => typeof data[key] === 'string').map((key) => [key, data[key]]));
}

/** Active child modes publish typed input observations; unmounted modes remove their context. */
export function useScienceTutorSection(name: string, inputs: Record<string, unknown>) {
  const registry = useContext(Registry);
  const id = useId();
  const serialized = JSON.stringify(inputs);
  useEffect(() => {
    const label = name.replace(/([a-z])([A-Z])/g, '$1 $2');
    registry?.update(id, { name: label, inputs: JSON.parse(serialized) as Record<string, unknown> });
  }, [registry, id, name, serialized]);
  useEffect(() => () => registry?.update(id, null), [registry, id]);
}
